// extracted by mini-css-extract-plugin
export var empty = "BookmarksList-module--empty--4d56e";
export var eyebrow = "BookmarksList-module--eyebrow--18bb3";
export var item = "BookmarksList-module--item--9ad98";
export var list = "BookmarksList-module--list--7c370";
export var remove = "BookmarksList-module--remove--61a1a";
export var title = "BookmarksList-module--title--763c3";